import { Component, ComponentInterface, h, VNode } from '@stencil/core';

import { UniHostTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

@Component({ tag: 'uni-layout-row' })
export class UniLayoutRowComponent implements ComponentInterface {

  render(): VNode {
    const classes = { 'row': true };

    return UniHostTemplate({ classes }, <slot />);
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
